import * as React from 'react';
import { getEventUrl } from 'constants/pages';
import { CoachStatusEnum } from 'types/generated/client';
import CoachBadge from 'svg/CoachBadge';
import Link from 'components/Link';
import CardNotification from './CardNotification';
import { NotificationTypeSelectorProps } from '../types';
import { NotificationStatusesEnum } from 'types/generated/client';

interface TournamentPartnerRequestReceivedNotificationProps
  extends NotificationTypeSelectorProps {
  status: NotificationStatusesEnum;
}

const TournamentPartnerRequestReceivedNotification: React.FC<
  TournamentPartnerRequestReceivedNotificationProps
> = ({ notification, status }) => {
  const actorFullName =
    notification?.notificationDetails?.primaryEntity?.actingUserProfile?.fullName ?? 'A player';
  const actorCoachStatus =
    notification?.notificationDetails?.primaryEntity?.actingUserProfile?.coachStatus;
  const eventId = notification?.notificationDetails?.primaryEntity?.eventGroup?.event?.id;

  const content = (
    <CardNotification status={status}>
        <div className="p-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center text-xs font-semibold leading-5">
              {actorFullName}{' '}
              {actorCoachStatus === CoachStatusEnum.Active && (
                <div className="h-4 w-4 text-color-brand-primary">
                  <CoachBadge className="h-6 w-6" />
                </div>
              )}
            </div>
            <div className="rounded-xl bg-color-brand-primary px-2 text-xs leading-5 text-color-text-lightmode-invert">
              Partner Request
            </div>
          </div>
          <div className="mt-1 text-xs leading-5">Requested to be your tournament partner</div>
        </div>
    </CardNotification>
  );

  if (!eventId) {
    return content;
  }

  return <Link href={getEventUrl(eventId)} className="block">{content}</Link>;
};

export default TournamentPartnerRequestReceivedNotification;
